import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown", "form", "currentStatus", "button", "menu"]
  static values = {
    status: String
  }
  
  static outlets = ["confirmation-dialog"]


  connect() {
    // Hide dropdown menu initially
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add('hidden')
    }
    
    // Close dropdown when clicking outside
    document.addEventListener('click', this.closeDropdown.bind(this))
  }
  
  disconnect() {
    // Remove event listeners when controller is disconnected
    document.removeEventListener('click', this.closeDropdown.bind(this))
  }
  
  toggleDropdown(event) {
    event.stopPropagation()
    if (this.hasMenuTarget) {
      this.menuTarget.classList.toggle('hidden')
    }
  }
  
  closeDropdown(event) {
    // Don't close if clicking on the button itself (that's handled by toggleDropdown)
    if (this.hasButtonTarget && this.buttonTarget.contains(event.target)) {
      return
    }
    
    // Close the dropdown menu
    if (this.hasMenuTarget && !this.menuTarget.classList.contains('hidden')) {
      this.menuTarget.classList.add('hidden')
    }
  }
  
  // Handle selecting a status from the dropdown
  selectStatus(event) {
    const selectedStatus = event.currentTarget.dataset.statusUpdateStatusValue
    const currentStatus = this.currentStatusTarget.value
    
    if (selectedStatus !== currentStatus) {
      // Get the humanized status name from the span
      const statusLabel = event.currentTarget.querySelector('span').textContent.trim()
      
      // Set the selected status
      this.statusValue = selectedStatus
      
      // Close the dropdown menu
      if (this.hasMenuTarget) {
        this.menuTarget.classList.add('hidden')
      }
      
      // Use the outlet to access the confirmation dialog controller
      if (this.hasConfirmationDialogOutlet) {
        // Configure the dialog
        this.confirmationDialogOutlet.configure({
          title: 'Update Status',
          message: `Change status to <span class="font-medium">${statusLabel}</span>?`,
          buttonText: 'Update',
          actionType: 'update',
          callerController: this
        })
        
        // Open the dialog
        this.confirmationDialogOutlet.open()
      }
    }
  }
  
  // Method that will be called by the confirmation dialog controller
  confirmAction() {
    this.confirmStatusChange()
  }
  
  // Confirm status change and submit the form
  confirmStatusChange() {
    // Update the hidden dropdown to match the selected status
    if (this.hasDropdownTarget && this.statusValue) {
      this.dropdownTarget.value = this.statusValue
    }
    
    // Submit the form
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
    }
  }
}
